import { render, staticRenderFns } from "./water.vue?vue&type=template&id=6b8ba224&"
import script from "./js/water.js?vue&type=script&lang=js&"
export * from "./js/water.js?vue&type=script&lang=js&"
import style0 from "./water.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports